export default "__VITE_ASSET__CF11dAqd__"